import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard")({
  component: Dashboard,
  loader: () => {
    return {
      crumb: "Dashboard"
    };
  }
});

function Dashboard() {
  return (
    <div className="p-2">
      <h3>Dashboard</h3>
    </div>
  );
}
